<template>
  <CCard class="contactNotes">
    <CRow>
      <CCol sm="12">
        <header class="contactNotes__header d-flex justify-content-between">
          <h3 class="contactNotes__title font-weight-normal">
            {{ $t('audience.detailContact.notes') }}
          </h3>
          <CButton color="white" class="py-2 px-4" @click.prevent="sendSubscriptions" :disabled="!notes.length">
            {{ $t('audience.detailContact.button.addNotes') }}
          </CButton>
        </header>
      </CCol>
      <CCol sm="12">
        <div class="contactNotes__body p-0 mt-4">
          <div v-if="loading" class="d-flex flex-column justify-content-center align-items-center bg-gray-200 p-5">
            <CSpinner class="my-3" color="primary" />
          </div>
          <CForm v-else class="contactNotes__form">
            <CTextarea
              v-model="notes"
              :placeholder="$t('audience.detailContact.placeholder')"
              addLabelClasses="text-gray-600 font-20"
              addInputClasses="contactNotes__textarea  p-3 text-gray-700 font-base"
            />
          </CForm>
        </div>
      </CCol>
      <CCol sm="12">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
      </CCol>
    </CRow>
  </CCard>
</template>

<script>
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'
export default {
  name: 'ContactNotes',
  components: {
    MenssageAlert,
  },
  data() {
    return {
      notes: '',
      loading: false,
      recipient: [],
      messages: [],
    }
  },

  methods: {
    sendSubscriptions() {
      this.messages = []
      this.loading = true

      services
        .recipientNotes(this.$route.params.organizationId, this.$route.params.id, {
          content: this.notes,
          userId: this.$store.state.auth.user.id,
        })
        .then(({ data }) => {
          this.messages.push({
            status: 'success',
            text: data.message || 'Your note was saved',
          })

          this.$emit('addNewNote')
        })

        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })

        .finally(() => {
          this.notes = ''
          this.loading = false
        })
    },
  },

  computed: {
    getterRecipient() {
      if (this.$store.state.audience.recipient) {
        return JSON.parse(JSON.stringify(this.$store.state.audience.recipient))
      }
      return []
    },
  },
  watch: {
    getterRecipient(newValues) {
      this.recipient = newValues
    },
  },
}
</script>

<style lang="scss">
.contactNotes {
  background: none;
  border: none;
  box-shadow: none !important;

  &__textarea {
    background: transparent;
    min-height: 179px;

    &.form-control {
      border: 1px solid $gray-500;
      box-shadow: none !important;
    }
  }
}
</style>
